export default __webpack_public_path__ + "static/media/characters.e8af8432.png";